import { useQuery } from "@tanstack/react-query";
import { ApiGetUserInviteLevel } from "@/api";

export const useUserInviteLevel = () => {
  return useQuery({
    queryKey: ["userInviteLevel"],
    queryFn: async () => {
      const res = await ApiGetUserInviteLevel();
      console.log("useUserInviteLevel", res.data);
      return res.data;
    },
  });
};
